export const CDN_URl =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// export const LOGO_URL =
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQoLI_uxIDAxCCK46tTEBxgIbto8Znd9-GBfQ&s";

export const LOGO_URL =
  "https://api.logo.com/api/v2/images?design=lg_rVsEIGhchOEPV5HFuQ&u=1730784295485&width=500&height=400&margins=100&fit=contain&format=webp&quality=60";

